<template>
  	<div class="success-container">
  		<div class="success-table">
  			<div class="success-tables">
  				<div class="success-title"><img src="../../../assets/img/success-head.png" ></div>
  				<div class="success-name">{{username}}</div>
  				<div class="success-success">恭喜登顶</div>
  				<div class="success-number">斩获最高分：{{score}}分</div>
  				<div class="success-btn"><a href="javascript:;" @click="$emit('closeCD')">返回</a></div>
  			</div>
  		</div>
  	</div>
</template>

<script>
  import {getCookie} from '../../../untils/common.js'
  import {ApiGetResult} from '../../../net/cdjs/index.js'
  export default {
    data: function () {
      return {
        username: '',
        userImage: '',
        score: 0
      }
    },
    props: ['resultId'],
    methods: {
      getReult: function () {
        const pramas = {
          resultId: this.$props.resultId
        }
        ApiGetResult(pramas).then(res=>{
          console.log('res', res)
          if (res.code == 200) {
            this.score = res.value.score
          }
        })
      }
    },
    mounted: function () {
      const user = JSON.parse(getCookie('user'))
      // console.log('uesr', user)
      this.username = user.realName
      this.userImage = user.userImage || 'http://statics.sgn.7east.cn/photo/20201207172318.png'
      this.getReult()
    }
  }
</script>

<style scoped>
.success-container{
  background-image: url(../../../assets/img/successbgimg.png);
  background-repeat: no-repeat;
  background-size: 375px 680px;
  width: 375px;
  height: 680px;
  overflow: hidden;
  margin:0 auto;
  overflow-y: auto;
}
.success-table{
  width: 340px;
  margin:0 auto;
  height: 370px;
  border-radius: 16px;
  margin-top: 280px;
  background-color: rgba(246,192,0,0.3);
  overflow: hidden;
}
.success-tables{
  text-align: center;
  margin: 20px;
  width: 300px;
  height: 330px;
  background: rgba(255,255,255,0.9);
  border-radius: 10px;
}
.success-title{
  width: 150px;
  margin: 0 auto;
  margin-top: -90px;
  position: absolute;
  margin-left: 80px;
}
.success-title img{
  width: 150px;
}
.success-name{
  font-size:18px;
  color:#252525;
  padding-top: 90px;
  font-weight: 600;
}
.success-success{
  font-size: 32px;
  color: #E50012;
  font-weight: 600;
  padding-top: 20px;
}
.success-number{
  font-size: 14px;
  color: #999999;
  margin-top: 20px;
}
.success-btn{
  width: 150px;
  height: 40px;
  margin:0 auto;
  overflow: hidden;
  margin-top: 30px;
}
.success-btn a{
  width: 148px;
  height: 38px;
  border-radius: 28px;
  text-align: center;
  float: left;
  font-size: 16px;
  line-height: 38px;
  text-decoration: none;
  color: #999;
  border:1px solid #ccc;
}
.success-btn a:hover{
  color: #fff;
  background: linear-gradient(to right,#F01A15, #FE7832);
  width: 150px;
  height: 40px;
  border:none;
}
.success-title img{
}
</style>



// WEBPACK FOOTER //
// src/components/Cdjs/children/success.vue